import { render, staticRenderFns } from "./TraceyAiQueryNav.vue?vue&type=template&id=bc6f683c&scoped=true"
import script from "./TraceyAiQueryNav.vue?vue&type=script&lang=js"
export * from "./TraceyAiQueryNav.vue?vue&type=script&lang=js"
import style0 from "./TraceyAiQueryNav.vue?vue&type=style&index=0&id=bc6f683c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6f683c",
  null
  
)

export default component.exports